import { TrendingDown, TrendingUp } from 'lucide-react';
import formatMetricValue from '../helpers/formatMetricValue';
import { GlobalMetricValueFormat } from '../types';
import { MetricChangeContainer, MetricChangeIcon } from './styled';

export interface MetricChangeProps {
    value?: number;
    valueFormat?: GlobalMetricValueFormat;
    goodWhen?: 'positive' | 'negative';
}

const MetricChange = ({ value = 0, valueFormat, goodWhen = 'positive' }: MetricChangeProps) => {
    const formattedValue = formatMetricValue(Math.abs(value), valueFormat);
    const changePositive = value > 0;
    if (!value) return null;
    return (
        <MetricChangeContainer $positive={changePositive} $goodWhen={goodWhen}>
            <MetricChangeIcon>
                {changePositive ? (
                    <TrendingUp />
                ) : (
                    <TrendingDown />
                )}
            </MetricChangeIcon>
            {`${changePositive ? '+' : '-'}${formattedValue}`}
        </MetricChangeContainer>
    );
};

export default MetricChange;
